import React, { useState, useContext } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Button,
  Divider,
  TextField,
  Typography,
} from "@material-ui/core";
import { UserDataContext } from "../Contexts/UserDataContext";
import Snack from "./Snack";
const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  block: {
    marginTop: theme.spacing(4),
  },
  field: {
    padding: theme.spacing(2),
  },
  action: {
    padding: theme.spacing(2),
  },
  feedback: {
    color: "red",
    fontWeight: "bold",
  },
}));

const ChangePasswordForm = () => {
  const classes = useStyles();
  const [snackOpen, setSnackOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    password1: "",
    password2: "",
    feedback: "",
  });
  const { userData, setUserData } = useContext(UserDataContext);
  const [passwordFeedback, setPasswordFeedback] = useState("");

  const changePassword = async (token, newPassword) => {
    const request = {
      method: "POST",
      url: `/users/changepassword`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${token}`,
      },
      data: { password: newPassword },
    };
    try {
      const response = await axios(request);
      setSnackOpen(true);
      setPasswordForm({ ...passwordForm, feedback: "" });
      setUserData({ ...userData, resetPassword: false });
      return response;
    } catch (error) {
      // setSnackOpen(true);
      setPasswordForm({ ...passwordForm, feedback: "" });
      console.log(JSON.stringify(error));
      return error;
    }
  };

  const handlePasswordChange = async () => {
    if (passwordForm.password1 === passwordForm.password2) {
      changePassword(userData.token, passwordForm.password1);
    } else {
      setPasswordForm({ ...passwordForm, feedback: "Passwords do not match" });
    }
  };

  const passwordStrengthTests = [
    {
      test: (password) => password.length >= 8,
      feedback: "Password must be at least 8 characters long.",
    },
    {
      test: (password) => password.length <= 20,
      feedback: "Password must be no longer than 20 characters.",
    },
    {
      test: (password) => /[a-z]+/.test(password),
      feedback: "Password must contain at least one lowercase letter.",
    },
    {
      test: (password) => /[A-Z]+/.test(password),
      feedback: "Password must contain at least one uppercase letter.",
    },
    {
      test: (password) => /\d+/.test(password),
      feedback: "Password must contain at least one digit.",
    },
    {
      test: (password) => /[!@#$%^&*_\-.?]+/.test(password),
      feedback: "Password must contain at least one symbol.",
    },
  ];

  const onUpdatePassword = (event) => {
    const failSome = passwordStrengthTests.some((strengthTest) => {
      const pass = strengthTest.test(event.target.value);
      !pass && setPasswordFeedback(strengthTest.feedback);
      return !pass;
    });

    !failSome && setPasswordFeedback("");

    setPasswordForm({
      ...passwordForm,
      password1: event.target.value,
    });
  };

  return (
    <Card className={classes.block}>
      <CardHeader title="Change Password" />
      <Divider />
      <CardContent>
        <Typography className={classes.feedback}>
          {passwordForm.feedback}
        </Typography>
        <Grid container>
          <Grid item xs={12} className={classes.field}>
            <TextField
              label="Enter New Password"
              placeholder="Password"
              type="password"
              fullWidth
              onChange={onUpdatePassword}
              helperText={passwordFeedback}
            />
          </Grid>
          <Grid item xs={12} className={classes.field}>
            <TextField
              label="Confirm New Password"
              placeholder="Password"
              type="password"
              fullWidth
              onChange={(event) =>
                setPasswordForm({
                  ...passwordForm,
                  password2: event.target.value,
                })
              }
            />
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardActions className={classes.action}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handlePasswordChange()}
          disabled={passwordFeedback !== ""}
        >
          Submit
        </Button>
      </CardActions>
      <Snack
        snackOpen={snackOpen}
        setSnackOpen={setSnackOpen}
        variant={"success"}
        message={"successful"}
      />
    </Card>
  );
};

export default ChangePasswordForm;
